export default "__VITE_ASSET__Dsz$bjfZ__"